export default __webpack_public_path__ + "static/media/loggy.75934545.PNG";